import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from "constants/index"

export const GET_PROFIT_BY_PRODUCTS = "[PROFIT REPORT] GET PROFIT BY PRODUCTS"
export const GET_PROFIT_BY_SALES = "[PROFIT REPORT] GET PROFIT BY SALES"

export function getProfitByProducts(filters) {
  const request = api.get(`/profit-report/by-products`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_PROFIT_BY_PRODUCTS, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_PROFIT_BY_PRODUCTS, payload: { loading: false, ...response.data } })
    }).catch((err) => {
      dispatch({ type: GET_PROFIT_BY_PRODUCTS, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener las utilidades de los productos")
      console.log(GET_PROFIT_BY_PRODUCTS, err)
    })
  }
}

export function getProfitBySales(filters) {
  const request = api.get(`/profit-report/by-sales`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_PROFIT_BY_SALES, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_PROFIT_BY_SALES, payload: { loading: false, ...response.data } })
    }).catch((err) => {
      dispatch({ type: GET_PROFIT_BY_SALES, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener las utilidades de las ventas")
      console.log(GET_PROFIT_BY_SALES, err)
    })
  }
}
